import React from "react";
import { string, bool, func } from "prop-types";
import { PriceTypeDropdownCommon } from "./PriceTypeDropdownCommon";

export const PriceTypeDropdown = (props: any) => {
  return (
    <PriceTypeDropdownCommon
      componentLabel={props.componentLabel}
      defaultValue={props.defaultValue}
      showAll={props.showAll}
      onChange={props.onChange}
      visualStyle="old"
    />
  );
};

PriceTypeDropdown.propTypes = {
  componentLabel: string,
  defaultValue: string,
  showAll: bool,
  onChange: func,
};
